import { ComponentType, SVGProps } from 'react';
import { iconRegistry } from './generated/export';

const isErrorLogged: Record<string, boolean> = {};

export const getIconFromRegistry = (
  iconName?: string,
): ComponentType<SVGProps<SVGSVGElement>> | undefined => {
  if (!iconName) {
    return undefined;
  }

  const icon = iconRegistry[iconName]?.icon;

  if (!icon) {
    !isErrorLogged[iconName] && console.error(`Icon not found for ${iconName}`);
    isErrorLogged[iconName] = true;
    return undefined;
  }

  return icon;
};
